// Utilidades compartidas por los drawers de trazabilidad (Fase 9).

export const Z_INDEX_BASE = 1100;

/** offset lateral por nivel — cada drawer anidado se corre 40px a la izq. */
export const OFFSET_PER_LEVEL = 40;

export const hexToRgba = (hex, alpha = 0.18) => {
  if (typeof hex !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(hex)) {
    return `rgba(148, 163, 184, ${alpha})`;
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const x = new Date(d);
    return x.toLocaleDateString('es-CL', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '—';
  }
};

export const fmtDateTime = (d) => {
  if (!d) return '—';
  try {
    const x = new Date(d);
    return x.toLocaleString('es-CL');
  } catch {
    return '—';
  }
};

export const fmtMoney = (valor, moneda) => {
  const decimals = moneda === 'CLP' ? 0 : 2;
  const symbol = moneda === 'UF' ? 'UF' : moneda === 'USD' ? 'US$' : '$';
  const n = Number(valor ?? 0).toLocaleString('es-CL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${symbol} ${n}`;
};

export const drawerPropsFromLevel = (level = 0) => ({
  mask: level === 0,
  maskClosable: false,
  style: {
    marginRight: level * OFFSET_PER_LEVEL,
  },
  zIndex: Z_INDEX_BASE + level * 10,
});

export const STATUS_LABEL = {
  esperando_aprobar: 'Esperando aprobar',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
  cancelado: 'Cancelado',
  en_espera: 'En espera',
  odt_no_asignada: 'ODT sin asignar',
  odt_asignada: 'ODT asignada',
  odt_en_proceso: 'ODT en proceso',
  odt_finalizada: 'ODT finalizada',
};

export const STATUS_ANTD_COLOR = {
  esperando_aprobar: 'gold',
  aprobado: 'green',
  rechazado: 'red',
  cancelado: 'default',
  en_espera: 'orange',
  odt_no_asignada: 'blue',
  odt_asignada: 'processing',
  odt_en_proceso: 'processing',
  odt_finalizada: 'success',
};
